// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#table_planning .v-data-table__wrapper{max-height:calc(100vh - 295px);overflow-y:auto}.ligne_spv:hover td.colonne_nom{background-color:#e0e0e0!important}", ""]);
// Exports
module.exports = exports;
